import { FC } from 'react';
import dynamic from 'next/dynamic';

const AcePro2BoostNote = dynamic(import('./AcePro2BoostNote'));
const ProductComparison = dynamic(import('./ProductComparison'));

interface IProps {
  pid: number;
  cid: number;
  LANG: Record<string, string>;
}

/** 规格属性下方额外的组件展示，例如产品对比弹窗等 */
const BundleExtraModule: FC<IProps> = ({ pid, cid, LANG }) => {
  if (pid === 25) return <ProductComparison />;
  if (pid === 30) return <AcePro2BoostNote pid={pid} cid={cid} LANG={LANG} />;

  return null;
};

export default BundleExtraModule;
